import React from 'react';

import {
  CheckCircle as SuccessIcon,
  RemoveCircle as PartialIcon,
  Error as FailureIcon,
} from '@material-ui/icons';

import {
  red,
  yellow,
  green,
  grey,
} from '@material-ui/core/colors';

export default function StatusIcon(props) {
  const { status, className, style } = props;

  switch (status) {
    case 5:
      return <PartialIcon className={className} style={{ ...style, color: yellow[500] }} />;
    case 4:
      return <PartialIcon className={className} style={{ ...style, color: yellow[500] }} />;
    case 3:
      return <SuccessIcon className={className} style={{ ...style, color: green[500] }} />;
    case 2:
      return <PartialIcon className={className} style={{ ...style, color: yellow[500] }} />;
    case 1:
      return <FailureIcon className={className} style={{ ...style, color: red[500] }} />;
    default:
      return <PartialIcon className={className} style={{ ...style, color: grey[400] }} />;
  }
}
